module.exports = __webpack_public_path__ + "static/img/club.7494630e.svg";